<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="ownerReviews" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="ownerReviewId" [paginator]="showPaginator"
  [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true" currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" selectionMode="single" [(selection)]="ownerReview" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true"
  [autoLayout]="true" [responsive]="true">
  <ng-template pTemplate="caption">
    @if (!reservationId) {
      <input type="text" pInputText placeholder="Search" (input)="pt.filterGlobal($event.target.value, 'contains')"
        style="width:auto;">
    }
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">OwnerReviews</h1>
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onNewOwnerReviewButtonClick()">New OwnerReview +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    @if (!reservationId) {
      <tr>
        <th [pSortableColumn]="'ownerReviewId'">
          <p-sortIcon [field]="'ownerReviewId'"></p-sortIcon>Id
        </th>
        <th [pSortableColumn]="'status'">
          <p-sortIcon [field]="'status'"></p-sortIcon>Status
        </th>
        <th [pSortableColumn]="'shortTermRentalVO.propertyCode'">
          <p-sortIcon [field]="'shortTermRentalVO.propertyCode'"></p-sortIcon>Property
        </th>
        <th [pSortableColumn]="'rating'">
          <p-sortIcon [field]="'rating'"></p-sortIcon>Stars
        </th>
        <th>
          Length
        </th>
        <th [pSortableColumn]="'title'">
          <p-sortIcon [field]="'title'"></p-sortIcon>Title
        </th>
        <th [pSortableColumn]="'lastName'">
          <p-sortIcon [field]="'lastName'"></p-sortIcon>Name
        </th>
        <th [pSortableColumn]="'reviewDate'">
          <p-sortIcon [field]="'reviewDate'"></p-sortIcon>Received
        </th>
      </tr>
    }

    @if (reservationId) {
      <tr>
        <th>Id</th>
        <th>Status
        </th>
        <th>Property
        </th>
        <th>Stars
        </th>
        <th>
          Length
        </th>
        <th>Title
        </th>
        <th>Name
        </th>
        <th>Received
        </th>
      </tr>
    }

    @if (!reservationId) {
      <tr>
        <td><input pInputText style="width:50px;" type="number"
        (input)="pt.filter($event.target.value, 'ownerReviewId', 'in')"></td>
        <td>
          <p-dropdown [style]="{'min width':'50px'}" [options]="statuses"
            (onChange)="pt.filter($event.value, 'status', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </td>
        <td><input pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'in')"></td>
        <td><input pInputText style="width:50px;" type="text"
        (input)="pt.filter($event.target.value, 'rating', 'in')"></td>
        <td></td>
        <td></td>
        <td><input pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'lastName', 'in')"></td>
        <td><input pInputText style="width:100px;" type="date"
        (input)="pt.filter($event.target.value, 'reviewDate', 'in')"></td>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-ownerReview>
    <tr [pSelectableRow]="ownerReview">
      <td>{{ownerReview.ownerReviewId}}</td>
      @if (ownerReview.status==1) {
        <td style="color: grey;">{{getStatusName(ownerReview)}}</td>
      }
      @if (ownerReview.status==2) {
        <td style="color: blue;">{{getStatusName(ownerReview)}}</td>
      }
      @if (ownerReview.status==3) {
        <td style="color: green;">{{getStatusName(ownerReview)}}</td>
      }
      @if (ownerReview.status==4) {
        <td style="color: red;">{{getStatusName(ownerReview)}}</td>
      }

      <td>{{ownerReview.propertyCode}}</td>

      <td>
        <p-rating [(ngModel)]="ownerReview.rating" readonly=true stars=5></p-rating>
      </td>
      <td>{{ownerReview?.reviewDesc?.length}}</td>
      <td><b>{{ownerReview.title}}</b></td>
      <td>{{ownerReview.lastName}}</td>
      <td>{{ownerReview.reviewDate | date:'shortDate'  }}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} - {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first)
  : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
</p-table>